import React, { FC } from 'react'

import { UserRequiredFieldsCard } from '../../cards/UserRequiredFieldsCard/UserRequiredFieldsCard'
import { IconArrowCircleRight } from '../../../../../icons/IconArrowCircleRight'
import { ClassesTab } from '../ClassesTab/ClassesTab'
import { FeesTab } from '../FeesTab/FeesTab'
import { TicketsTab } from '../TicketsTab/TicketsTab'
import { PaperworkTab } from '../PaperworkTab/PaperworkTab'
import { TeamTab } from '../TeamTab/TeamTab'
import { HorsesTab } from '../HorsesTab/HorsesTab'

import { IUserInterface } from '../../../../../../models/users/user.interface'
import { IEventReviewPublish } from '../../../../../../models/event-review-publish/event-review-publish.interface'
import { IRegistrationByDayInterface } from '../../../../../../models/registrations-by-day/registrationByDay.interface'

import { RIDER_TABS } from '../../../RiderInfoModal/RiderInfoModal'

interface OverviewTabProps {
  user: IUserInterface | null
  setActiveTab: (tab: string) => void
  publishedEvent: IEventReviewPublish | null

  riders: IRegistrationByDayInterface[]
  registrarId: string
  eventId: string
  organizer: IUserInterface | null
  registrationId: string
  riderId: string
}
export const OverviewTab: FC<OverviewTabProps> = ({
  user,
  setActiveTab,
  publishedEvent,
  riders,
  registrarId,
  eventId,
  organizer,
  registrationId,
  riderId,
}) => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div className="flex flex-col gap-5">
          <UserRequiredFieldsCard
            activeTab="overview"
            user={user}
            eventRequiredUserFields={publishedEvent?.EventRequiredFields.requiredFields}
            actionIcon={<IconArrowCircleRight className="!w-[30px] !h-[30px]" />}
            onActionClick={() => setActiveTab(RIDER_TABS.PROFILE.value)}
          />
          <ClassesTab
            type="overview"
            registrarId={registrarId}
            registrationId={registrationId}
            eventId={eventId}
            organizer={organizer}
            user={user}
            publishedEvent={publishedEvent}
            actionIcon={<IconArrowCircleRight className="!w-[30px] !h-[30px]" />}
            onActionClick={() => setActiveTab(RIDER_TABS.CLASSES.value)}
          />
          <FeesTab
            type="overview"
            registrarId={registrarId}
            registrationId={registrationId}
            eventId={eventId}
            publishedEvent={publishedEvent}
            user={user}
            organizer={organizer}
            actionIcon={<IconArrowCircleRight className="!w-[30px] !h-[30px]" />}
            onActionClick={() => setActiveTab(RIDER_TABS.FEES.value)}
          />
        </div>
        <div className="flex flex-col gap-5">
          <TicketsTab
            type="overview"
            registrarId={registrarId}
            registrationId={registrationId}
            eventId={eventId}
            publishedEvent={publishedEvent}
            user={user}
            organizer={organizer}
            actionIcon={<IconArrowCircleRight className="!w-[30px] !h-[30px]" />}
            onActionClick={() => setActiveTab(RIDER_TABS.TICKETS.value)}
          />
          <PaperworkTab
            type="overview"
            registrationsByDay={riders}
            eventId={eventId}
            userId={riderId}
            registrationId={registrationId}
            actionIcon={<IconArrowCircleRight className="!w-[30px] !h-[30px]" />}
            onActionClick={() => setActiveTab(RIDER_TABS.PAPERWORK.value)}
          />
          <TeamTab
            type="overview"
            registrationId={registrationId}
            user={user}
            publishedEvent={publishedEvent}
            actionIcon={<IconArrowCircleRight className="!w-[30px] !h-[30px]" />}
            onActionClick={() => setActiveTab(RIDER_TABS.TEAM.value)}
          />
          <HorsesTab
            activeTab="overview"
            registrationsByDay={riders}
            publishedEvent={publishedEvent}
            actionIcon={<IconArrowCircleRight className="!w-[30px] !h-[30px]" />}
            onActionClick={() => setActiveTab(RIDER_TABS.TEAM.value)}
          />
        </div>
      </div>
    </>
  )
}
